import React from "react";
import PropTypes from "prop-types";

/* eslint-disable react/forbid-prop-types */

const ICOMOON_MAP = {
  menu: "slnsw-icon-Hamburger",
  close: "slnsw-icon-CollectionClose",
  play: "slnsw-icon slnsw-icon-PlaySolid2Play",
  pause: "slnsw-icon slnsw-icon-PlaySolid2Pause",
  next: "slnsw-icon slnsw-icon-ActionButtonCaret",
  zoomIn: "slnsw-icon slnsw-icon-ZoomInOL2",
  zoomOut: "slnsw-icon slnsw-icon-ZoomOutOL2",
  zoomReset: "slnsw-icon slnsw-icon-ZoomResOL2"
};

const IcomoonIcon = ({ iconName, className, children, tag = "i" }) => {
  if (!ICOMOON_MAP[iconName]) {
    return [];
  }
  const Component = tag;
  if (React.Children.count(children) > 0) {
    return (
      <Component className={[ICOMOON_MAP[iconName], className || ""].join(" ")}>
        {children}
      </Component>
    );
  }
  return (
    <Component className={[ICOMOON_MAP[iconName], className || ""].join(" ")} />
  );
};

IcomoonIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
  tag: PropTypes.string
};

IcomoonIcon.defaultProps = {
  className: "",
  children: [],
  tag: "i"
};

export default IcomoonIcon;
